import { BillingTypes } from "@/types/project/billing_types"
import Tracking from "@/types/tracking/tracking"

export default class Project {
  public constructor (init?:Partial<Project>) {
    Object.assign(this, init)
  }

  public id: string | null = null;
  public name: string | null = null;
  public userId: string | null = null;
  public owner = true
  public active: boolean | null = null;
  public description: string | null = null;
  public billingType: BillingTypes | null = null;
  public salary: number | null = null;
  public trackedTimes: Tracking[] | null = null;
}
